
export default function parseAddress(gmapResults, key, shortName = false) {
    const address = gmapResults[0];

    var result = '';
    address.address_components.forEach((component) => {
        let index = component.types.indexOf(key);
        if (index > -1) {
            result = shortName ? component.short_name : component.long_name
        }
    });

    return result;

}